import { render, staticRenderFns } from "./cargoAttributes.vue?vue&type=template&id=461a56d9&scoped=true"
import script from "./cargoAttributes.vue?vue&type=script&lang=js"
export * from "./cargoAttributes.vue?vue&type=script&lang=js"
import style0 from "./cargoAttributes.vue?vue&type=style&index=0&id=461a56d9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461a56d9",
  null
  
)

export default component.exports